import { faCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const RadioList = ({ detail }) => {
  return (
    <>
      <div className="flex mb-6">
        <span>
          <FontAwesomeIcon icon={faCircle} style={{ color: "#6d625a " }} size="xs" />
        </span>
        <span className="font-agcasmlt text-[#6d625a] font-light text-lg sm:text-xl ml-4 md:ml-8">{detail}</span>
      </div>
    </>
  )
}

export default RadioList